import Pricing from './pricing';

export default Pricing;
